import React from 'react';
import { useHistory } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import styled from 'styled-components';
import { CommonStyledComponentProps } from '__utils/type';
import { isBtoCFlow } from '__utils/common-utils';
import { Col, Row } from 'antd';
import { COLOR } from 'constants/colors';

import SipCalcImage from 'images/sip-calc.svg';
import GoalAmountImage from 'images/target-amount-calc.svg';
import RightArrowBlack from '../../images/right-arrow-black.svg';

const CalculatorContainer = styled.div <CommonStyledComponentProps>`
    .calculator-wrap {
        min-height: 105px;
        flex-flow: inherit;
        overflow-x: auto;
        -ms-overflow-style: none;
        scrollbar-width: none;
    }
    .calculator-card {
        display: grid;
        grid-template-columns: ${(props) => props.isMobile ? '70px 10px' : 'auto 290px'};
        grid-column-gap: 7px;
        align-items: center;
        padding: 10px 16px 10px 10px;
        background: ${COLOR.WHITE};
        box-shadow: 0px 3.75904px 7.51807px rgba(146, 145, 145, 0.12);
        cursor: pointer;
        border-radius: 8px;
    }
    .img-sec {
        max-width: 75px;
        min-height: 72px;
        display: grid;
        justify-items: center;
    }
    .txt-section-calc {
        width: ${(props) => props.isMobile ? 'max-content' : 'auto'};
        max-width: ${(props) => props.isMobile ? "calc(100vw - 165px)" : ''};
        background: url(${RightArrowBlack}) no-repeat right center;
    }
    .txt-section {
        padding-right: ${(props) => props.isMobile ? '20px' : '20px'};
    }
    .txt-section h5 {
        color: #3E4647;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        padding-bottom: 7px;
    }
    .txt-section p {
        color: #414040;
        font-size: 12px;
        line-height: 16px;
    }
`;

const CalculatorSlider: React.FC = () => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const history = useHistory();
  return(
    <CalculatorContainer isMobile={isMobile}>
        <Row className='calculator-wrap' gutter={16}>
            <Col xs={22} md={9} className="calc">
                <div className={`calculator-card`} onClick={() => history.push('sip-calculator')}>
                    <div className="img-sec">
                        <img src={SipCalcImage} alt="" />
                    </div>
                    <div className="txt-section txt-section-calc">
                        <h5>SIP Calculator</h5>
                        <p>{isBtoCFlow() ? 'Plan your monthly investments and know your future wealth' : "Plan your client's monthly investments and help them know the future wealth"}</p>
                    </div>
                </div>
            </Col>
            <Col xs={22} md={9}>
                <div className={`calculator-card`} onClick={() => history.push('goal-amount-calculator')}>
                    <div className="img-sec">
                        <img src={GoalAmountImage} alt="" />
                    </div>
                    <div className="txt-section txt-section-calc">
                        <h5>Goal Amount Calculator</h5>
                        <p>{isBtoCFlow() ? "Use our calculator to see how much you need to save to reach your financial goals." : "Use our calculator to see how much your client needs to save to reach their financial goals."}</p>
                    </div>
                </div>
            </Col>
        </Row>
        </CalculatorContainer>
  )
}
export default CalculatorSlider;